<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Kernkompetenz · Beratung</p>

      <h2 class="presentation-page__title">Kernkompetenz Beratung</h2>

      <p class="presentation-page__text">
        Wir rechnen Ihr Projekt vor der ersten Schraube durch — konservativ, transparent,
        bankentauglich.
      </p>

      <div class="presentation-page__process-rows">
        <article v-for="step in steps" :key="step.number" class="presentation-page__process-row">
          <div
            :class="[
              'presentation-page__process-row-accent',
              step.accent === 'brand-teal'
                ? 'presentation-page__process-row-accent--brand-teal'
                : '',
            ]"
            aria-hidden="true"
          ></div>

          <div
            :class="[
              'presentation-page__process-row-step',
              step.accent === 'brand-teal' ? 'presentation-page__process-row-step--brand-teal' : '',
            ]"
          >
            {{ step.number }}
          </div>

          <div class="presentation-page__process-row-icon" aria-hidden="true">
            <i :class="['fa', step.icon]"></i>
          </div>

          <h3 class="presentation-page__process-row-title">{{ step.title }}</h3>

          <div class="presentation-page__process-row-divider" aria-hidden="true"></div>

          <p class="presentation-page__process-row-text">{{ step.text }}</p>
        </article>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage31',

  components: { PrintPageLandscape, PresentationPage },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      steps: [
        {
          number: 1,
          accent: 'brand-primary',
          icon: 'fa-user',
          title: 'Kundenbedarfsanalyse',
          text:
            'Verbrauchsprofil, Lastgang, Strategiefragen wie Eigenverbrauch vs. Volleinspeisung — wir hören zuerst zu.',
        },
        {
          number: 2,
          accent: 'brand-teal',
          icon: 'fa-sun-o',
          title: 'Standort- und Ertragsanalyse',
          text:
            'Verschattung, Ausrichtung, Modulbelegung — Ertragssimulation P50 / P75 / P90 mit anerkannten Tools.',
        },
        {
          number: 3,
          accent: 'brand-primary',
          icon: 'fa-calculator',
          title: 'Wirtschaftlichkeitsberechnung',
          text:
            'Cashflow über 20 Jahre, IRR, Amortisation. Drei Szenarien (Garantie-, Median-, Optimalfall).',
        },
        {
          number: 4,
          accent: 'brand-teal',
          icon: 'fa-file-text-o',
          title: 'Regulatorische & technische Klärung',
          text:
            'EEG, Marktstammdatenregister, Netzanschluss, Messkonzept, Genehmigungslogik je Bundesland.',
        },
        {
          number: 5,
          accent: 'brand-primary',
          icon: 'fa-cogs',
          title: 'Optimale Anlagenstruktur',
          text:
            'Kauf, Pacht, PPA, Mieterstrom, IAB-Modell, IPP-Beteiligung — wir empfehlen die Struktur, die zu Ihnen passt.',
        },
      ],
    };
  },
};
</script>
